/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowFatLinesUp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M231.39111,123.06152A8.00015,8.00015,0,0,1,224,128H184v24a8.00008,8.00008,0,0,1-8,8H80a8.00008,8.00008,0,0,1-8-8V128H32a8.0001,8.0001,0,0,1-5.65674-13.65723l96-96a8.00182,8.00182,0,0,1,11.31348,0l96,96A8.00061,8.00061,0,0,1,231.39111,123.06152ZM176,208H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0-32H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z" />
    </Svg>
  );
}

export default ArrowFatLinesUp;
